import * as React from 'react';
import { getColorValue } from '../utilities/color';

function CannotEdit(props) {
  const gray = getColorValue('illustrationGray');
  const accent = getColorValue('illustrationAccentGray');
  const line = getColorValue('illustrationStroke');

  return (
    <svg fill="none" height="275" viewBox="0 0 275 275" width="275" {...props}>
      <clipPath id="a">
        <path d="m0 0h275v275h-275z" />
      </clipPath>
      <g clipPath="url(#a)">
        <path
          d="m252.19 144h-10.33l-4.97-12.52h-27.99c.44-25.89 3.08-49.87 7.82-71.48h-135.86c-.4 3.92-.76 7.89-1.1 11.88h-39.17l4.97 12.53h49.51l4.97 12.53h-21.99c0 .16-.02.32-.03.48l-.19-.48h-59.83l4.97 12.53h17.63l4.97 12.53h31.62c-.11 5.4-.17 10.83-.17 16.32 0 17.97.55 35.37 1.6 52.21h-23.58l4.97 12.53h-14.95l4.97 12.53h166.35c-2.33-10.82-4.12-22.23-5.38-34.19h-21.76l-4.97-12.53h17.38l-4.97-12.53 60.49.18-4.97-12.53z"
          fill={gray}
        />
        <g fill={accent}>
          <path d="m77.1799 122h28.8201l-4.97-12.53h-23.8501z" />
          <path d="m81.11 215.6h28.82l-4.97-12.54h-24.74z" />
          <path d="m208.17 143.83h-18.28l4.97 12.54h4.58 8.73z" />
        </g>
        <path
          d="m161.94 117.29c-2.34-2.07-5.91-1.85-7.98.49l-3.22 3.64 8.45 7.52 3.25-3.67c2.07-2.34 1.85-5.91-.49-7.98z"
          fill={line}
        />
        <path
          d="m147.34 125.25-14.8 16.74-5.51 14.76 13.98-7.27v.01l14.81-16.74z"
          fill={line}
        />
        <path d="m129 151.479-1.97 5.27 4.99-2.6z" fill={line} />
        <path
          d="m124.07 113.84 44.88 44.88"
          stroke={line}
          strokeMiterlimit={10}
          strokeWidth="5.94"
        />
        <path
          d="m177.58 143.5c.4-2.24.61-4.62.61-7.14s-.21-4.97-.62-7.23c-2.42-13.49-11.8-21.81-24.94-23.95-2.24-.36-4.59-.55-7.04-.55-2.55 0-5 .2-7.33.59-13.15 2.2-22.51 10.49-24.94 23.91-.41 2.27-.62 4.68-.62 7.23s.21 4.9.61 7.14c2.41 13.4 11.77 21.71 24.95 23.91 2.33.39 4.78.59 7.33.59 2.45 0 4.8-.19 7.04-.55 13.16-2.14 22.55-10.47 24.95-23.95z"
          stroke={line}
          strokeMiterlimit={10}
          strokeWidth="5.94"
        />
      </g>
    </svg>
  );
}

export default CannotEdit;
